import React, { useState } from 'react';
import axios from 'axios';
import './ResetPassword.css'; // Style as needed
  import { getStoredData } from "../../api/fetchData.jsx";

const ResetPassword = () => {
  const [step, setStep] = useState(1); // 1 = enter email, 2 = enter OTP + new password
  const [emailId, setEmailId] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");


  const stored = getStoredData();
  const baseApi = stored?.[0]?.Api || "http://localhost:5000"; // fallback if not set

  const handleSendOtp = async () => {
    try {
      await axios.post(`${baseApi}/user/forgot-password`, { emailId });
      setStep(2);
      setMessage("OTP sent to your email.");
      setError("");
    } catch (err) {
      setError("Failed to send OTP. Check email.");
      setMessage("");
    }
  };

  const handleResetPassword = async () => {
    try {
      await axios.post(`${baseApi}/user/reset-password`, {
        emailId,
        otp,
        newPassword,
      });
      setMessage("Password reset successful. You can now log in.");
      setError("");
      setStep(1);
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to reset password");
      setMessage("");
    }
  };

  return (
    <div className="reset-container">
      <h2>Password Reset</h2>

      {step === 1 && (
        <>
          <label>Email</label>
          <input
            type="email"
            value={emailId}
            onChange={(e) => setEmailId(e.target.value)}
            placeholder="Enter your registered email"
          />
          <button onClick={handleSendOtp}>Send OTP</button>
        </>
      )}

      {step === 2 && (
        <>
          <label>OTP</label>
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            placeholder="Enter OTP from email"
          />
          <label>New Password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
          />
          <button onClick={handleResetPassword}>Reset Password</button>
        </>
      )}

      {message && <p className="success">{message}</p>}
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default ResetPassword;
